import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';

import {latency} from '@app/core/config/app.config';
import {ScoreData} from '@app/core/models/score.data';
import {ScoreModel} from '@app/core/models/score.model';

@Injectable({providedIn: 'root'})
export class ScoreService {
  public list(): Observable<ScoreModel[]> {
    return of(ScoreData).pipe(delay(latency));
  }
}
